// tasks
export const GET_TASKS = '/company/tasks'

export const GET_DELETE_TASK = '/company/task/:taskUuid'
export const POST_TASK = '/company/task'
export const GET_DELETE_TASK_ATTACHMENT =
  '/company/task/:taskUuid/attachment/:index'

export const POST_ATTACHMENT = '/company/attachment'
export const GET_DELETE_ATTACHMENT = '/company/task/:taskUuid/attachment/:index'
export const DELETE_ATTACHMENT = '/company/attachment/:attachmentUuid'
export const DELETE_TASK_ATTACHMENT =
  '/company/task/:taskUuid/attachment/:index'
export const GET_TASK = '/company/task/:uuid'
export const GET_TASK_HISTORY = '/company/taskHistory/:uuid'
export const GET_TASK_COMMENTS = '/company/task/:uuid/comments'

export const POST_TASK_COMMENT = '/company/task/:taskUuid/comment'
export const DELETE_TASK_COMMENT = '/company/taskComment/:taskCommentUuid'
export const GET_TASK_COMMENT_ATTACHMENT =
  '/company/taskComment/:taskCommentUuid/attachment'

export const GET_USERS_WITH_ACCESS_TO_PATIENTS = '/company/user'

export const TASK_SAVE_MESSAGE = 'Action has been successfully saved!'
export const TASK_DELETE_MESSAGE = 'Action has been successfully deleted!'
export const TASK_CONFIRM_DELETE_MESSAGE = 'Do you want to delete the action?'
export const TASK_DISABLED_CLOSE_MESSAGE =
  "You are not the creator of the action or haven't been assigned to it yet."
export const TASK_DISABLED_DELETE_MESSAGE =
  "The action can't be deleted as there are notes left in the action thread."
export const TASK_COMMENT_SAVE_MESSAGE =
  'Action comment has been successfully saved!'
export const TASK_COMMENT_DELETE_MESSAGE =
  'Action comment has been successfully deleted!'
export const CARE_GAP_ATTACHCHMENT =
  '/company/careGap/:taskUuid/attachment/:careGapCustomFieldValueUuid'

export const TASK_LIST_DEFAULT_SORT = {
  sortedColumn: 'lastActivity',
  sortedColumnOrder: 'descend'
}

export const TASK_STATUS_LIST = new Map([
  [
    0,
    {
      className: 'status',
      title: '-',
      value: 0
    }
  ],
  [
    1,
    {
      className: 'status status_new',
      title: 'New',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'status status_in-progress',
      title: 'In progress',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'status status_closed',
      title: 'Closed',
      value: 3
    }
  ]
])

export const TASK_PRIORITY_LIST = new Map([
  [
    0,
    {
      className: 'priority priority_none',
      title: '-',
      value: 0
    }
  ],
  [
    1,
    {
      className: 'priority priority_low',
      title: 'Low',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'priority priority_medium',
      title: 'Medium',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'priority priority_high',
      title: 'High',
      value: 3
    }
  ]
])

export const TASK_PRIORITY_LIST_DROPDOWN = Array.from(TASK_PRIORITY_LIST)
  .map(([key, { title, value }]) => ({
    key,
    title,
    value
  }))
  .filter(({ key }) => key !== 0)

export const TASK_PRIORITY_LIST_DROPDOWN_WITH_ALL = [
  {
    key: 0,
    title: 'All',
    value: 0,
    children: TASK_PRIORITY_LIST_DROPDOWN
  }
]

export const ACTION_TYPES = [
  { title: 'Task', key: 'task' },
  { title: 'Notification', key: 'notification' }
]

export const ACTION_TYPES_PAYER = [
  ...ACTION_TYPES
  // TODO uncomment { title: 'Care Gap', key: 'careGap' }
]

export const ACTION_TYPES_DROPDOWN = ACTION_TYPES.map(({ title, key }) => ({
  title,
  key,
  value: key
}))

export const ACTION_TYPES_PAYER_DROPDOWN = ACTION_TYPES_PAYER.map(
  ({ title, key }) => ({
    title,
    key,
    value: key
  })
)

export const ACTION_TYPES_DROPDOWN_WITH_ALL = [
  { key: 0, title: 'All', value: 0 },
  ...ACTION_TYPES_DROPDOWN
]

export const ACTION_TYPES_PAYER_DROPDOWN_WITH_ALL = [
  { key: 0, title: 'All', value: 0 },
  ...ACTION_TYPES_PAYER_DROPDOWN
]
